import React, { useEffect, useState } from "react"

import TEST_ID_CONSTANTS from "~config/test-id-constants"
import COPY_CONSTANTS from "~config/copy-constants"
import { captureSentryException } from "~root/sentry"

type HubspotFormProps = {
    readonly formId: string
}

export default function HubspotForm({ formId }: HubspotFormProps) {
    const [isClient, setIsClient] = useState(false)
    const PORTAL_ID = process.env.GATSBY_HUBSPOT_ID
    const SCRIPT_URL = `https://js.hsforms.net/forms/embed/${PORTAL_ID}.js`

    useEffect(() => {
        setIsClient(true)

        const script = document.createElement("script")
        script.src = SCRIPT_URL
        script.defer = true
        script.onload = () => {
            console.log(COPY_CONSTANTS.HUBSPOT.SCRIPT_LOADED)
        }
        script.onerror = () => {
            captureSentryException(
                new Error(COPY_CONSTANTS.HUBSPOT.SCRIPT_LOAD_ERROR)
            )
        }
        document.body.appendChild(script)

        return () => {
            document.body.removeChild(script)
        }
    }, [SCRIPT_URL])

    if (!isClient || !formId) {
        return null
    }

    return (
        <div
            className="hs-form-frame"
            data-form-id={formId}
            data-portal-id={PORTAL_ID}
            data-testid={TEST_ID_CONSTANTS.HUBSPOT_FORM_CONTAINER}
        />
    )
}
